//import axios from 'axios';
import { setAlert } from './alert';
import * as types from './types';


const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

//Get account list
export const getAccounts = () => async dispatch => {
    await sleep(750);
    try {
        const res = { data: [{ id: 1, name: 'Tax-Free Saving Account', code: 'TFSA', description: 'A Tax-Free Savings Account is a flexible, registered, general-purpose savings vehicle that allows Canadians to earn tax-free investment income to more easily meet lifetime needs. Investment income inside a TFSA is tax-free, as are withdrawals from a TFSA. Please see <a href="https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/tax-free-savings-account.html" target="_blank">www.canada.ca/en/revenue-agency/services/tax/individuals/topics/tax-free-savings-account.html</a> for more details.', selected: false, hidden: false, recommendedGoals: [1, 2, 3, 4], accsToAdd: [] }, { id: 2, name: 'Registered Retirement Saving Plan', code: 'RRSP', description: 'A Registered Retirement Savings Plan is a plan that you establish and register to contribute towards your retirement income. Contributions to an RRSP can be used to reduce your tax payable. Income you earn in an RRSP is usually exempt from tax as long as the funds remain in the plan. You generally have to pay tax when you receive payments from the plan. Please see <a target="_blank" href="www.cra-arc.gc.ca/tx/ndvdls/tpcs/rrsp-reer/rrsps-eng.html">www.cra-arc.gc.ca/tx/ndvdls/tpcs/rrsp-reer/rrsps-eng.html</a> for more details.', selected: false, hidden: false, recommendedGoals: [1], accsToAdd: [] }, { id: 3, name: 'Spousal Registered Retirement Saving Plan', code: 'SRRSP', description: 'A Spousal Retirement Savings Plan is a registered plan that you establish for your spouse or common-law partner to contribute towards your retirement income. Contributions to your SRRSP can be used to reduce your partner’s payable tax amount. Income you earn in an SRRSP is usually exempt from tax as long as the funds remain in the plan. You generally have to pay tax when you receive payments from the plan. Please see <a target="_blank" href="www.cra-arc.gc.ca/tx/ndvdls/tpcs/rrsp-reer/rrsps-eng.html">www.cra-arc.gc.ca/tx/ndvdls/tpcs/rrsp-reer/rrsps-eng.html</a> for more details.', selected: false, hidden: false, recommendedGoals: [1], accsToAdd: [] }, { id: 4, name: 'Locked-In Retirement Account', code: 'LIRA', description: 'A Locked-In Retirement Account is a plan containing funds transferred from a pension plan or another locked-in retirement account. Generally, funds transferred into a LIRA cannot be withdrawn and will be used to buy a life annuity at retirement. You can transfer funds from a LIRA to another locked-in retirement fund. Please see <a target="_blank" href="www.cra-arc.gc.ca/E/pub/tg/t4040/t4040-e.html#locked_in">www.cra-arc.gc.ca/E/pub/tg/t4040/t4040-e.html#locked_in</a> for more details.', selected: false, hidden: false, recommendedGoals: [1], accsToAdd: [] }, { id: 5, name: 'Registered Education Saving Plan', code: 'RESP', description: 'A Family RESP is a contract between an individual (the subscriber, which is likely you) and an organization whereby ONE OR MORE future students, called beneficiaries of the plan, will receive payments as part of an educational assistance plan. Contributions to an RESP are not deductible on your tax return, but growth in the value of the investments held is tax-free. Please see <a target="_blank" href="www.cra-arc.gc.ca/tx/ndvdls/tpcs/resp-reee/hw-eng.html">www.cra-arc.gc.ca/tx/ndvdls/tpcs/resp-reee/hw-eng.html</a> for more information on how an RESP works.', selected: false, hidden: false, recommendedGoals: [2], accsToAdd: [] }, { id: 6, name: 'Non-Registered Account', code: 'NON-REG', description: 'An account for general savings or investment purposes that will not be registered with the federal government for tax credits or deductions.', selected: false, hidden: false, recommendedGoals: [1, 2, 3, 4], accsToAdd: []  /*[{goalID:1, current: true}] */ }] };
        //const res = await axios.get('/api/accounts');
        dispatch({
            type: types.GET_ACCOUNTS,
            payload: res.data
        })
    } catch (error) {
        dispatch(setAlert('API Error', 'is-danger'));
    }
}




















// //Get profile by id
// export const getProfileById = userId => async dispatch => {
//     try {
//         const res = await axios.get(`/api/profile/user/${userId}`);
//         dispatch({
//             type: types.GET_PROFILE,
//             payload: res.data
//         })
//     } catch (error) {
//         dispatch({
//             type: types.PROFILE_ERROR,
//             payload: { msg: error.response.statusText, status: error.response.status }
//         })
//     }
// }

// //Get all profiles
// export const getProfiles = () => async dispatch => {
//     dispatch({ type: types.CLEAR_PROFILE });
//     try {
//         const res = await axios.get('/api/profile/all');
//         dispatch({
//             type: types.GET_PROFILES,
//             payload: res.data
//         })
//     } catch (error) {
//         dispatch({
//             type: types.PROFILE_ERROR,
//             payload: { msg: error.response.statusText, status: error.response.status }
//         })
//     }
// }

// //Create or update profile
// export const createProfile = (formData, history, edit = false) => async dispatch => {
//     try {
//         const config = {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         }

//         const res = await axios.post('/api/profile', formData, config);
//         dispatch({
//             type: types.GET_PROFILE,
//             payload: res.data
//         });

//         dispatch(setAlert(edit ? 'Profile updated' : 'Profile Created'));

//         if (!edit) {
//             history.push('/dashboard');
//         }

//     } catch (error) {
//         const errs = error.response.data.errors;
//         if (errs) {
//             errs.forEach(error => dispatch(setAlert(error.msg, 'danger')));
//         }
//         dispatch({
//             type: types.PROFILE_ERROR,
//             payload: { msg: error.response.statusText, status: error.response.status }
//         })
//     }
// }

// //Add experience
// export const addExperience = (formData, history) => async dispatch => {
//     try {
//         const config = {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         }

//         const res = await axios.post('/api/profile/experience', formData, config);
//         dispatch({
//             type: types.UPDATE_PROFILE,
//             payload: res.data
//         });

//         dispatch(setAlert('Experience Added', 'success'));

//         history.push('/dashboard');
//     } catch (error) {
//         const errs = error.response.data.errors;
//         if (errs) {
//             errs.forEach(error => dispatch(setAlert(error.msg, 'danger')));
//         }
//         dispatch({
//             type: types.PROFILE_ERROR,
//             payload: { msg: error.response.statusText, status: error.response.status }
//         })
//     }
// }

// //Add education
// export const addEducation = (formData, history) => async dispatch => {
//     try {
//         const config = {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         }

//         const res = await axios.post('/api/profile/education', formData, config);
//         dispatch({
//             type: types.UPDATE_PROFILE,
//             payload: res.data
//         });

//         dispatch(setAlert('Education Added', 'success'));

//         history.push('/dashboard');
//     } catch (error) {
//         const errs = error.response.data.errors;
//         if (errs) {
//             errs.forEach(error => dispatch(setAlert(error.msg, 'danger')));
//         }
//         dispatch({
//             type: types.PROFILE_ERROR,
//             payload: { msg: error.response.statusText, status: error.response.status }
//         })
//     }
// }

// //Delete experience
// export const deleteExperience = id => async dispatch => {
//     try {
//         const res = await axios.delete(`/api/profile/experience/${id}`);
//         dispatch({
//             type: types.UPDATE_PROFILE,
//             payload: res.data
//         });
//         dispatch(setAlert('Experience Removed', 'success'));
//     } catch (error) {
//         dispatch({
//             type: types.PROFILE_ERROR,
//             payload: { msg: error.response.statusText, status: error.response.status }
//         })
//     }
// }

// //Delete education
// export const deleteEducation = id => async dispatch => {
//     try {
//         const res = await axios.delete(`/api/profile/education/${id}`);
//         dispatch({
//             type: types.UPDATE_PROFILE,
//             payload: res.data
//         });
//         dispatch(setAlert('Education Removed', 'success'));
//     } catch (error) {
//         dispatch({
//             type: types.PROFILE_ERROR,
//             payload: { msg: error.response.statusText, status: error.response.status }
//         })
//     }
// }

// //Delete account
// export const deleteAccount = id => async dispatch => {
//     if (!window.confirm('Are you sure? This can not be undone!')) return;
//     try {
//         const res = await axios.delete(`/api/profile`);
//         dispatch({
//             type: types.CLEAR_PROFILE,
//             payload: res.data
//         });
//         dispatch({
//             type: types.ACCOUNT_DELETED,
//             payload: res.data
//         });
//         dispatch(setAlert('Ypur account has been permanently deleted'));
//     } catch (error) {
//         dispatch({
//             type: types.PROFILE_ERROR,
//             payload: { msg: error.response.statusText, status: error.response.status }
//         })
//     }
// }